import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { Refresh as RefreshIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';
import tools from 'data/common/tools';
import moment from 'moment';
import { getSecurities } from '../../data/Security/actions';

class Security extends Component {
    static propTypes = {
        initialized: PropTypes.bool.isRequired,
        getSecurities: PropTypes.func.isRequired,
        Securities: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshSecurities();
    }

    /* NAVIGATION */
    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `securities/detail/${rowData.id}` });
    };

    /* ACTIONS */
    refreshSecurities = () => {
        const { getSecurities } = this.props;
        this.setState({ loading: true });
        return getSecurities()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    /* RENDER */
    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRight = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`general.products.Security.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshSecurities
                }
            ]
        };
        if (profile.get('admin') || userRight.includes('securityDetails')) {
            actions.row.push({
                icon: ViewIcon,
                tooltip: Translator.translate(`general.showDetail`),
                onClick: this.navigateToDetail
            });
        }
        return actions;
    });

    renderData = memoizeOne(Securities => {
        let result = [];
        Securities.map(Security => {
            const lastConnection = Security.get('lastConnection');
            result.push({
                id: Security.get('macAddress'),
                macAddress: Security.get('macAddress')
                    .match(/.{1,2}/g)
                    .join(':'),
                label: Security.get('label'),
                email: Security.get('userEmail'),
                productType: Translator.translate(`general.products.Security.table.data.productType.${Security.get('productType')}`),
                firmwareVersion: Security.get('firmwareVersion'),
                usersList: Security.get('usersList'),
                userMasterId: Security.get('userMasterId'),
                batteryLevel: Security.get('batteryLevel'),
                alarmState: Security.get('alarmState'),
                notifications: Security.get('notifications'),
                lastConnection: lastConnection ? moment(lastConnection).format('DD/MM/YYYY HH:MM:ss') : null
            });
        });
        return result;
    });
    renderColumns = memoizeOne(profile => {
        const { history, classes } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.macAddress'),
                name: 'macAddress',
                width: 150,
                customFilter: tools.filterMacAddress
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('securityDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.productType'),
                name: 'productType'
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.firmwareVersion'),
                name: 'firmwareVersion',
                customSort: tools.sortVersion
            },
            {
                title: Translator.translate('general.table.column.batteryLevel'),
                name: 'batteryLevel'
            },
            {
                title: Translator.translate('general.table.column.alarmState'),
                name: 'alarmState'
            },
            {
                title: Translator.translate('general.table.column.notifications'),
                name: 'notifications'
            },
            {
                title: Translator.translate('general.table.column.lastConnection'),
                name: 'lastConnection',
                render: (row, data, value) => {
                    if (value) {
                        return value;
                    } else {
                        return <span className={classes.noConnection}>{Translator.translate('general.noConnection')}</span>;
                    }
                }
            }
        ];
    });
    render() {
        const { loading } = this.state;
        const { profile, Securities } = this.props;

        return (
            <FHETable
                idTable="securityList"
                columns={this.renderColumns(profile)}
                data={this.renderData(Securities)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`general.products.Security.table.title`)}
                emptyDataSourceMessage={Translator.translate(`general.products.Security.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const users = state.environments[history.environment].data.Users.get('list');
    let Securities = state.environments[history.environment].data.Security.get('list');
    Securities = Securities.map(Security => {
        const masterId = Security.getIn(['userMasterId'], '');
        return Security.setIn(['userEmail'], users.getIn([masterId && masterId.toString(), 'email'], ''));
    });

    return {
        profile: state.data.user,
        Securities,
        initialized: state.environments[history.environment].data.Security.get('initialized')
    };
}
const styles = theme => ({
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    },
    noConnection: {
        color: theme.palette.colors.red500
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getSecurities }, dispatch)
    )(withStyles(styles, { withTheme: true })(Security))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/Security/index.js